import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { ManagedUserGroupIntegration } from "types/generated";

import ManageSlackAccessContext from "../../../context";
import { showManageSlackAccessDetailsDrawer } from "../../DetailsDrawer";
import { showDeleteConfirmation } from "../../DeleteConfirmation";
import useDeleteIntegration from "../../DeleteConfirmation/useDeleteIntegration";

const SlackTableDropdownActionsCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupIntegration>) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const { activationStatus } = useTypedContext(ManageSlackAccessContext);
  const { onDelete, loading } = useDeleteIntegration();

  const handleAccessDetailsClick = useCallback(() => {
    showManageSlackAccessDetailsDrawer({
      currentIntegration: integration,
      activationStatus,
    });
  }, [integration, activationStatus]);

  const handleRemoveIntegration = useCallback(() => {
    onDelete(integration.id)
      .then(() => {
        reportSuccess({
          message: `Slack access was deleted`,
        });
      })
      .catch(onError);
  }, [integration.id, onDelete, onError, reportSuccess]);

  const handleDeleteConfirm = useCallback(() => {
    showDeleteConfirmation({
      onConfirm: handleRemoveIntegration,
      name: integration.integrationName,
    });
  }, [handleRemoveIntegration, integration.integrationName]);

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Slack access actions" dotsSize="small">
        <DropdownMenuItem onAction={handleAccessDetailsClick}>Access details</DropdownMenuItem>
        <DropdownMenuItem danger onAction={handleDeleteConfirm} loading={loading}>
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default SlackTableDropdownActionsCell;
